import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Expert } from "../_types/expert";

@Injectable({
    providedIn: 'root',
})
export class ExpertsService extends Service<Expert> {
    public override type = 'experts';
    public override url = 'attendance/experts';
}
